export default function Style() {
  return (
    <style>
      {`
       .POF-sub-title{
    font-family: 'Josefin Sans';
    color: #1B1B1B;
}
.POF-sub-para{
    font-family: 'Josefin Sans';
    color: #5E5E5E;
}
        `}
    </style>
  );
}
